<template>
  <div class="page-content">
    <page-template ref="billFranchiseTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '单号',
              prop: 'orderNo',
              type: 'input',
              ifFuzzy: true,
              placeholder: "单号"
            }
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "加盟店",
              type: "select",
              prop: "franchiseStoreId",
              span: 12,
              data: []
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              type: 'select',
              span: 12,
              defaultValue: 20,
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '打印',
            code: 'print',
            filter: () => {
              return false
            }
          },
          {
            label: '导出',
            code: 'export',
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              callback: this.goOrderDetail
            },
            {label: '加盟店', prop: 'franchiseStoreName', width: '150', align: 'center'},
            {
              label: '状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('stFranchiseStoreBillOrder.reviewerStatus')
            },
            {label: '单据金额', prop: 'billAmount', width: '120', align: 'center'},
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center',},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center',},
            {label: '备注', prop: 'remarks', width: '120', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate(),},
          url: api.settle.billFranchise
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            }, {
              label: '加盟店',
              prop: 'franchiseStoreName',
            }, {
              label: '单据金额',
              prop: 'billAmount',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            stFranchiseStoreBillMapList: {
              url: api.settle.franchiseStoreBillMap + "/page",
              showSummary: true,
              indexShow: true,
              height: this.detailHeight,
              tableName: "stFranchiseStoreBillMapList",
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'allocationOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: '业务类型',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stFranchiseStoreBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'allocationDttm',
                  align: "center"
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            stFranchiseStoreBillMapList: {
              tableName: 'stFranchiseStoreBillMapList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'allocationOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: '业务类型',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stFranchiseStoreBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'allocationDttm',
                  align: "center"
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.billFranchise
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.getStore();
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(() => {
      //   this.tableOptions.url = api.settle.billFranchise
      //   this.$refs['billFranchiseTemplate'].operationSuccess();
      // })
    },
    methods: {
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/bill/franchise/detail?id=' + row.id,
          query: {redirect: '/bill/franchise'}
        }).catch(err => {
        });
      },
      toEditPage(row) {
        this.$router.push({path: '/bill/franchise/add?id=' + row.id}).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/bill/franchise/add'});
      },
      getStore() {
        this.$axios.fetchPost(api.store.store + '/list', {storeClass: 2}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === "franchiseStoreId")[0].data = data.data;
          } else {
            this.$message({message: "获取加盟店失败", type: "error"});
          }
        })
      }
    }
  };
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/page/settle/franchise/BillFranchise.vue